import {Modal} from '@hm/fundamental'
import React from 'react'

import {IntroStep} from './IntroStep'
import {PersonalizeStep} from './PersonalizeStep'
import {useWelcomeFlow} from './useWelcomeFlow'

export const WelcomeModal: React.FC = () => {
  const {isOpen, closeModal, step, setStep} = useWelcomeFlow()

  return (
    <Modal open={isOpen} onClose={closeModal} data-cy="welcome_flow_modal" isExitEnabled={false}>
      {step === 'intro' && <IntroStep onContinue={() => setStep('selectPersona')} />}
      {step === 'selectPersona' && <PersonalizeStep closeModal={closeModal} />}
    </Modal>
  )
}
